import * as PropTypes from 'prop-types';
import {createUseStyles, useTheme} from 'react-jss';
import {connect} from 'react-redux';
import EditDeleteAddressTypes from '../../../../../enums/EditDeleteAddressTypes';
import Button from '../../../../../UI/Button/Button';
import {hideOverlay} from '../../../../actions/overlay-actions';
import Translation from '../../../../lang/Translation';
import {isMobile} from '../../../../selectors/DeviceSelectors';
import Spacing from '../../../../style-helper/Spacing';
import Spinner from '../../../ui/Spinner';
import SuccessIcon from '../../../ui/svg/Components/SuccessIcon';
import CheckoutOverlay from '../../CheckoutOverlay';

const useStyles = createUseStyles({
  contentWrapper: {
    padding: [Spacing.triple, Spacing.double],
  },
  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: Spacing.single * 10,
    fill: '#eee',
  },
});

export function EditDeleteAddressSuccessOverlay(props) {
  const theme = useTheme();
  const classes = useStyles();
  
  const getTranslations = (type) => {
    if (type === EditDeleteAddressTypes.EDIT_ADDRESS) {
      return {
        title: 'checkout.delivery.editAddress.overlay.title',
        success: props.showSpinner ? 'checkout.delivery.editDeleteAddress.success.overlay.editInProgress'
          : 'checkout.delivery.editDeleteAddress.success.overlay.editSuccess',
      };
    } return {
      title: 'checkout.delivery.deleteAddress.overlay.title',
      success: props.showSpinner ? 'checkout.delivery.editDeleteAddress.success.overlay.deleteInProgress'
        : 'checkout.delivery.editDeleteAddress.success.overlay.deleteSuccess',
    };
  };
  
  return (
    <CheckoutOverlay
      popup
      stickyScaleToContentMobile
      ordersummary
      nopadding
      title={getTranslations(props.type).title}
      className="editDeleteAddressSuccessOverlay"
    >
      <div className={classes.contentWrapper} data-test="successText">
        <Translation>{getTranslations(props.type).success}</Translation>
        <div className={classes.iconContainer}>
          {props.showSpinner ? (
            <Spinner />
          ) : <SuccessIcon fill={theme.core.brand} />}
        </div>
        <Button
          primary
          fullWidth={!props.isMobile}
          id="closeEditDeleteSuccessOverlay"
          onClick={() => props.hideOverlay()}
          disabled={props.showSpinner}
        >
          <Translation>checkout.close.button</Translation>
        </Button>
      </div>
    </CheckoutOverlay>
  );
}

EditDeleteAddressSuccessOverlay.propTypes = {
  type: PropTypes.symbol.isRequired,
  isMobile: PropTypes.bool,
  showSpinner: PropTypes.bool,
  
  // Actions
  hideOverlay: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  isMobile: isMobile(state),
  showSpinner: state.address.deliveryAddressList.showSpinner,
});

export default connect(mapStateToProps, {hideOverlay})(EditDeleteAddressSuccessOverlay);
